var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcomingSessionDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.75,
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 12.5007H25.8327V11.6673C25.8327 11.209 25.4577 10.834 24.9993 10.834C24.541 10.834 24.166 11.209 24.166 11.6673V12.5007H15.8327V11.6673C15.8327 11.209 15.4577 10.834 14.9993 10.834C14.541 10.834 14.166 11.209 14.166 11.6673V12.5007H13.3327C12.416 12.5007 11.666 13.2507 11.666 14.1673V27.5007C11.666 28.4173 12.416 29.1673 13.3327 29.1673H26.666C27.5827 29.1673 28.3327 28.4173 28.3327 27.5007V14.1673C28.3327 13.2507 27.5827 12.5007 26.666 12.5007ZM25.8327 27.5007H14.166C13.7077 27.5007 13.3327 27.1257 13.3327 26.6673V16.6673H26.666V26.6673C26.666 27.1257 26.291 27.5007 25.8327 27.5007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingSessionDate);
export default __webpack_public_path__ + "static/media/upcomingSessionDate.a0d1f1f434e4d86b1381ffc4c24b41b1.svg";
export { ForwardRef as ReactComponent };